(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2197],{

/***/ 74414:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Page; }
/* harmony export */ });
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(35835);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34587);
/* harmony import */ var _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9605);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67597);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61395);
/* harmony import */ var _components_common__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51633);
/* harmony import */ var _components_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56090);
/* harmony import */ var _utils_axios__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82373);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(57611);



/* eslint-disable @next/next/next-script-for-ga */








function Page() {
  var _data$metadata, _data$metadata2, _data$metadata3, _data$metadata4, _data$metadata5;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(null),
      data = _useState[0],
      setData = _useState[1];

  var _useTranslation = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(),
      lang = _useTranslation.lang;

  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var fetchData = /*#__PURE__*/function () {
      var _ref = (0,_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)( /*#__PURE__*/_opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var _yield$Axios$get, data;

        return _opt_bakcell_frontend_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _utils_axios__WEBPACK_IMPORTED_MODULE_6__/* ["default"].get */ .Z.get('pages/404/', {
                  headers: {
                    'Accept-Language': lang
                  }
                });

              case 2:
                _yield$Axios$get = _context.sent;
                data = _yield$Axios$get.data;
                setData(data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function fetchData() {
        return _ref.apply(this, arguments);
      };
    }();

    fetchData();
  }, [lang]);
  return !!data && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_components_common__WEBPACK_IMPORTED_MODULE_4__/* .Layout */ .Ar, {
    navbar: data === null || data === void 0 ? void 0 : data.menu,
    footer: data === null || data === void 0 ? void 0 : data.footer,
    metadata: data === null || data === void 0 ? void 0 : data.metadata,
    breadcrumbs: data === null || data === void 0 ? void 0 : data.breadcrumbs,
    appDownload: data === null || data === void 0 ? void 0 : data.app_download_widget,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("title", {
        children: (data === null || data === void 0 ? void 0 : (_data$metadata = data.metadata) === null || _data$metadata === void 0 ? void 0 : _data$metadata.title) || (data === null || data === void 0 ? void 0 : data.name)
      }), (data === null || data === void 0 ? void 0 : (_data$metadata2 = data.metadata) === null || _data$metadata2 === void 0 ? void 0 : _data$metadata2.description) && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "description",
        content: data === null || data === void 0 ? void 0 : (_data$metadata3 = data.metadata) === null || _data$metadata3 === void 0 ? void 0 : _data$metadata3.description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("meta", {
        name: "keywords",
        content: (data === null || data === void 0 ? void 0 : (_data$metadata4 = data.metadata) === null || _data$metadata4 === void 0 ? void 0 : _data$metadata4.keywords) || (data === null || data === void 0 ? void 0 : (_data$metadata5 = data.metadata) === null || _data$metadata5 === void 0 ? void 0 : _data$metadata5.title) || 'Bakcell'
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_components_widget_wrapper_WidgetWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      widgets: data === null || data === void 0 ? void 0 : data.widgets
    })]
  });
}
Page.Layout = null;

/***/ }),

/***/ 20394:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/404",
      function () {
        return __webpack_require__(74414);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5443,1255,7847,6913,8922,5403,2030,9774,2888,179], function() { return __webpack_exec__(20394); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);